var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('button',{staticClass:"btn-with-counter",class:{
    'btn-with-counter--active': _vm.isActive,
    'btn-with-counter--transparency': _vm.addTransparency
  },on:{"click":function($event){return _vm.$emit('btn-with-counter-click')}}},[_c('span',{staticClass:"btn-with-counter__title"},[_vm._t("btn-content",function(){return [_vm._v("\n      "+_vm._s(_vm.title)+"\n    ")]})],2),_vm._v(" "),(!_vm.isEmptyItemsList)?_c('div',{staticClass:"btn-with-counter__counter"},[_vm._v(_vm._s(_vm.countItems))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }